import React, { Component, ReactNode, RefObject, createRef } from "react";
import { RenderContext, Renderer } from "vexflow";
import { Handler, SCORE_STORE_KEY } from "../common/handler";
import TopNavBar from "./TopNavBar";
import { NoteActionButton } from "./NoteActionButton";

//import styles
import "weui";
import "react-weui-ts/build/dist/react-weui.css";

import "../styles/vexEditor.css";
import { Button } from "react-weui-ts";
import ChordPopup from "./ChordPopup";
import axios from "axios";
import { getUrlParam } from "../utils/helpers";
import { base_url } from "../config";
import wx from "weixin-js-sdk";

export default class VexEditor extends Component {
  private containerRef: RefObject<HTMLCanvasElement> = createRef();

  private handler: Handler | null = null;

  state = {
    handler: null,
    sharpUpStatus: 0,
    sharpDownStatus: 0,
    showChordPopup: false,
    title: "",
  };

  constructor(props: any) {
    super(props);
  }

  async componentDidMount() {
    const render = new Renderer(
      this.containerRef.current ?? "",
      Renderer.Backends.CANVAS
    );
    render.resize(2000, 260);

    const handler = Handler.getInstance(render);

    const scoreString = localStorage.getItem(SCORE_STORE_KEY);
    let score = undefined;

    if (scoreString != null) {
      score = JSON.parse(scoreString);
    }

    const uuid = getUrlParam("id");
    const openid = getUrlParam("openid");
    
    let res: any;
    try {
      res = await axios.get(`${base_url}/staff`, {
        params: {
          id: uuid,
          openid: openid,
        },
      });

      if (res?.status == 200 && res?.data?.data?.content) {
        score = JSON.parse(res.data.data?.content);
        this.setState({ title: res.data.data?.title });
      } else {
        console.error("获取乐谱失败", res?.data?.data);
        this.setState({ title: "新建乐谱" });
      }
    } catch (e) {
      console.error("获取乐谱失败", e);
    }

    handler.init(score);
    handler.startListenTouchEvent(this.containerRef.current);

    this.handler = handler;
    this.setState({ handler });
  }

  componentWillUnmount(): void {
    this.handler?.stopListenTouchEvent(this.containerRef.current);
  }

  render(): ReactNode {
    const pickNote = (note: string | null) => {
      if (!this.handler) {
        return;
      }
      let duration = null;
      switch (note) {
        case "full":
          duration = "1";
          break;
        case "half":
          duration = "2";
          break;
        case "quarter":
        default:
          duration = "4";
          break;
      }

      this.handler.duration = duration;
    };

    const downKeys = () => {
      if (!this.handler) {
        return;
      }

      this.handler.downAllKeys();
    };

    const upKeys = () => {
      if (!this.handler) {
        return;
      }

      this.handler.upAllKeys();
    };

    const deleteNote = () => {
      this.handler?.deleteNote();
    };

    return (
      <React.Fragment>
        <TopNavBar
          title={this.state.title}
          pickNote={(note: string | null) => pickNote(note)}
          cleanAll={() => this.handler?.cleanAll()}
          handler={this.state.handler}
          showChordPopup={() => {
            this.setState({ showChordPopup: true });
          }}
        ></TopNavBar>
        <div className="canvas-container">
          <canvas ref={this.containerRef}/>
        </div>
        <NoteActionButton
          downAction={downKeys}
          upAction={upKeys}
          deleteAction={deleteNote}
        />
        <ChordPopup
          show={this.state.showChordPopup}
          close={() => {
            this.setState({ showChordPopup: false });
          }}
          handler={this.handler}
        ></ChordPopup>
      </React.Fragment>
    );
  }
}
